import { ModuleNameHr, SearchMode } from "../../models";
import { checkEmptyArray } from "../../services";
import { rootReducerInterface } from "../../typings/interfaces";

export const selectModules = (state: rootReducerInterface) =>
  state.global.modules;

export const selectModuleByName = (state: rootReducerInterface, name: string) =>
  state.global.modules.find(m => m.name === name);

export const selectCategories = (state: rootReducerInterface) =>
  state.global.categories;

export const selectCurrentModule = (state: rootReducerInterface) =>
  state.global.currentModule;

export const selectCurrentCategory = (state: rootReducerInterface) =>
  state.global.currentCategory;

export const selectCurrentCategories = (state: rootReducerInterface) =>
  selectCategories(state).filter(
    c => c.moduleRoute === selectCurrentModule(state)
  );

export const selectFilteredCategories = (state: rootReducerInterface) =>
  state.global.filteredCategories;

export const selectCurrentModuleName = ({
  global: { modules, currentModule }
}: rootReducerInterface) => {
  if (checkEmptyArray(modules) && currentModule) {
    return modules.find(m => m.route === currentModule).displayName;
  }

  return undefined;
};

export const selectRoutes = (state: rootReducerInterface) => state.global.routes;

export const selectIsAiMode = (state: rootReducerInterface) =>
  state.global.searchMode === SearchMode.ai;

export const selectIsAIFeedbackModalVisible = (state: rootReducerInterface) =>
  state.global.isAIFeedbackModalVisible;

export const selectIsAIFeedbackFormFilled = (state: rootReducerInterface) =>
  state.global.isAIFeedbackFormFilled;

export const selectIsContactModalVisible = (state: rootReducerInterface) =>
  state.global.isContactModalVisible;

export const selectPollPopup = (state: rootReducerInterface) =>
  state.global.pollPopup;



// WEBPACK FOOTER //
// ./src/containers/App/selectors.ts